export default __webpack_public_path__ + "static/media/bg_interview.e527ded2.svg";